import Styled from 'styled-components';

import { media } from '../../../lib/StyledComponents';

import { ICheckboxContain } from './common';

export const CheckboxContain = Styled.div<ICheckboxContain>`
  width: 100%;
  display: block;
  position: relative;
  padding: 0.4375em;
  margin-bottom: 1em;

  ${media.medium`
    margin-bottom: 0;
  `}
`;
